import { createSelector } from 'reselect';

const batchData = (state) => state.batchItemUpdatesData;

export const selectCreationFormData = () =>
  createSelector([batchData], (state) => state.creationForm);

export const selectSelectedTabData = () =>
  createSelector([batchData], (state) => state.selectedTab);
